'use strict';

var cov_zsu3mkjbz = function () {
  var path = 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\techs\\tech.js',
      hash = '592c71820581b01cc7adf045122718bd59d6db23',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\techs\\tech.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 8,
          column: 5
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_zsu3mkjbz.s[0];
angular.module('app').component('fountainTech', {
  templateUrl: 'app/techs/tech.html',
  bindings: {
    tech: '<'
  }
});